import { PaStatus } from "../enums/paStatus";
import { PaStatusBucket, PaStatusBucketLabels } from "../enums/paStatusBucket";
import { BadgeOption } from "./submissionSummaryOptions";

/**
 * Mapping of PA Status to available PA Status Bucket options.
 * Based on the business rules:
 * - Approved → (No predefined buckets)
 * - Denied → Denial on File, Not Covered / Plan Exclusion, Medically Unnecessary, Step Therapy Required
 * - Pending with insurance → (No predefined buckets)
 * - Auth Not Required → (No predefined buckets)
 * - Onshore Assistance → Done by Onshore
 * - NA Outcome → Asked Client Assistance, Expired, Processor Error, Unable to process through ePA - Call Required,
 *                Cancelled / Closed / Duplicate, Eligibility Error, Program Prerequisite, No Review Needed,
 *                Benefit Limitation, Unspecified System Failure, Others
 */
export const PA_STATUS_AND_BUCKET_MAPPING: Record<string, BadgeOption[]> = {
  [PaStatus.APPROVED]: [],
  [PaStatus.DENIED]: [
    {
      id: PaStatusBucket.DENIAL_ON_FILE,
      text: PaStatusBucketLabels[PaStatusBucket.DENIAL_ON_FILE],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.NOT_COVERED_PLAN_EXCLUSION,
      text: PaStatusBucketLabels[PaStatusBucket.NOT_COVERED_PLAN_EXCLUSION],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.MEDICALLY_UNNECESSARY,
      text: PaStatusBucketLabels[PaStatusBucket.MEDICALLY_UNNECESSARY],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.STEP_THERAPY_REQUIRED,
      text: PaStatusBucketLabels[PaStatusBucket.STEP_THERAPY_REQUIRED],
      textColor: "black",
      bgColor: "white",
    },
  ],
  [PaStatus.PENDING]: [],
  [PaStatus.AUTH_NOT_REQUIRED]: [],
  [PaStatus.ONSHORE_ASSISTANCE]: [
    {
      id: PaStatusBucket.DONE_BY_ONSHORE,
      text: PaStatusBucketLabels[PaStatusBucket.DONE_BY_ONSHORE],
      textColor: "black",
      bgColor: "white",
    },
  ],
  [PaStatus.NA_OUTCOME]: [
    {
      id: PaStatusBucket.ASKED_CLIENT_ASSISTANCE,
      text: PaStatusBucketLabels[PaStatusBucket.ASKED_CLIENT_ASSISTANCE],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.EXPIRED,
      text: PaStatusBucketLabels[PaStatusBucket.EXPIRED],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.PROCESSOR_ERROR,
      text: PaStatusBucketLabels[PaStatusBucket.PROCESSOR_ERROR],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.UNABLE_TO_PROCESS_CALL_REQUIRED,
      text: PaStatusBucketLabels[
        PaStatusBucket.UNABLE_TO_PROCESS_CALL_REQUIRED
      ],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.CANCELLED_CLOSED_DUPLICATE,
      text: PaStatusBucketLabels[PaStatusBucket.CANCELLED_CLOSED_DUPLICATE],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.ELIGIBILITY_ERROR,
      text: PaStatusBucketLabels[PaStatusBucket.ELIGIBILITY_ERROR],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.PROGRAM_PREREQUISITE,
      text: PaStatusBucketLabels[PaStatusBucket.PROGRAM_PREREQUISITE],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.NO_REVIEW_NEEDED,
      text: PaStatusBucketLabels[PaStatusBucket.NO_REVIEW_NEEDED],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.BENEFIT_LIMITATION,
      text: PaStatusBucketLabels[PaStatusBucket.BENEFIT_LIMITATION],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.UNSPECIFIED_SYSTEM_FAILURE,
      text: PaStatusBucketLabels[PaStatusBucket.UNSPECIFIED_SYSTEM_FAILURE],
      textColor: "black",
      bgColor: "white",
    },
    {
      id: PaStatusBucket.OTHERS,
      text: PaStatusBucketLabels[PaStatusBucket.OTHERS],
      textColor: "black",
      bgColor: "white",
    },
  ],
};
